function _containsWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}
module.exports = _containsWith;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_containsWith.js
// module id = gjyI
// module chunks = 5